const handleError = (error) =>
{
    return { error: error.response }
}

const APIErrorHandler = {
    handle: handleError
}

export default APIErrorHandler